import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminLayout.css';

function AdminLayout({ children }) {
  const { gebruiker, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-logo">
            WOM<span>sys</span>
          </div>
          <div className="admin-badge">ADMIN</div>
        </div>

        <nav className="admin-nav">
          <NavLink to="/admin" end>
            <span className="admin-nav-icon">📊</span>
            <span>Dashboard</span>
          </NavLink>
          <NavLink to="/admin/bedrijven">
            <span className="admin-nav-icon">🏢</span>
            <span>Bedrijven</span>
          </NavLink>
          <NavLink to="/admin/abonnementen">
            <span className="admin-nav-icon">💳</span>
            <span>Abonnementen</span>
          </NavLink>
          <NavLink to="/admin/facturen">
            <span className="admin-nav-icon">📄</span>
            <span>Facturen</span>
          </NavLink>
          <NavLink to="/admin/demo-aanvragen">
            <span className="admin-nav-icon">📋</span>
            <span>Demo Aanvragen</span>
          </NavLink>
          <NavLink to="/admin/ideeen">
            <span className="admin-nav-icon">💡</span>
            <span>Ideeën</span>
          </NavLink>
          <NavLink to="/admin/nieuws">
            <span className="admin-nav-icon">📰</span>
            <span>Nieuws</span>
          </NavLink>
          <NavLink to="/admin/nieuw">
            <span className="admin-nav-icon">🧾</span>
            <span>Changelog</span>
          </NavLink>
          <NavLink to="/admin/themas">
            <span className="admin-nav-icon">🎨</span>
            <span>Thema's</span>
          </NavLink>
          <a href="https://status.womsys.nl/?t=dk_test_f6124fbcb8a6d965ace08cbe" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', color: 'inherit', textDecoration: 'none' }}>
            <span className="admin-nav-icon">📊</span>
            <span>Server status</span>
          </a>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <div className="admin-user-name">{gebruiker?.gebruikersnaam}</div>
            <div className="admin-user-role">{gebruiker?.rol}</div>
          </div>
          <button onClick={() => navigate('/dashboard')} className="admin-btn-secondary">
            ← Naar app
          </button>
          <button onClick={handleLogout} className="admin-btn-logout">
            Uitloggen
          </button>
        </div>
      </aside>

      <main className="admin-content">
        {children}
      </main>
    </div>
  );
}

export default AdminLayout;
